import { render, staticRenderFns } from "./BankSelection.vue?vue&type=template&id=6cf6dfda&scoped=true&"
import script from "./BankSelection.vue?vue&type=script&lang=js&"
export * from "./BankSelection.vue?vue&type=script&lang=js&"
import style0 from "./BankSelection.vue?vue&type=style&index=0&id=6cf6dfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6dfda",
  null
  
)

export default component.exports